// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:18:32

export default {
  "id": "sprunki-popit",
  "slug": "sprunki-popit",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/49da11ad95bb4d33be9d522d472bfb7e-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/49da11ad95bb4d33be9d522d472bfb7e/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Sprunki PopIt",
      "description": "Sprunki PopIt: The Ultimate Bubble-Popping Adventure! Get ready for hours of bubbly fun with Sprunki PopIt, the free-to-play online game that kids everywhere are going crazy for! It’s fast, colorful, and packed with exciting challenges. Your goal? Pop all the bubbles, dodge obstacles, and conquer level after level of pure popping chaos!",
      "instructions": "Mouse to play.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "arcade",
        "avoid",
        "bubble",
        "collect",
        "point-and-click"
      ]
    },
    "zh-CN": {
      "title": "斯普伦基泡它",
      "description": "Sprunki PopIt：终极泡泡爆破冒险！准备好享受Sprunki PopIt带来的数小时欢乐泡泡吧，这是一款孩子们疯狂热爱的免费在线游戏！游戏节奏快速、色彩缤纷、充满刺激挑战。你的目标？爆破所有泡泡，躲避障碍，征服一个又一个纯泡泡混乱的关卡！",
      "instructions": "鼠标操作游戏。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "街机",
        "躲避",
        "泡泡",
        "收集",
        "点触操作"
      ]
    },
    "zh-TW": {
      "title": "水珠泡泡爆破",
      "description": "Sprunki PopIt：最終泡泡爆破冒險！準備好享受數小時的泡泡樂趣吧，與Sprunki PopIt這款免費在線遊戲一起，讓全世界的孩子瘋狂追捧！它快速度、色彩鮮豔，充滿刺激挑戰。你的目標是爆破所有泡泡、躲避障礙，征服一個又一個的纯粹爆破混亂關卡！",
      "instructions": "滑鼠操作。",
      "genres": [
        "隨意",
        "拼圖"
      ],
      "tags": [
        "電玩",
        "避障",
        "泡泡",
        "收集",
        "點擊選擇"
      ]
    },
    "zh-HK": {
      "title": "斯普林基泡普怡",
      "description": "Sprunki PopIt: 爆泡挑戰大冒險！準備好享受數小時的冒泡樂趣吧，Sprunki PopIt 是一款免費玩遊戲，全世界的孩童都瘋狂愛上它！遊戲快速、色彩鮮豔，充滿刺激挑戰。你的目標是爆破所有泡泡，躲避障礙，征服一個又一個的挑戰關卡！",
      "instructions": "滑鼠操作遊戲。",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "街機",
        "避開",
        "泡泡",
        "收集",
        "點擊選擇"
      ]
    },
    "ja": {
      "title": "スプリンキー・ポピット",
      "description": "スプリンキー・ポピット：究極の泡割りアドベンチャー！世界中の子供たちが狂喜する無料オンラインゲーム、スプリンキー・ポピットで、泡盛り楽しさに浸ろう！速くてカラフルで、興味深い挑戦が満載です。あなたの目標は、全ての泡を割り、障害物を避け、次々とレベルをクリアしていくことです！",
      "instructions": "マウスで遊ぶ。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "アーケード",
        "避け",
        "バブル",
        "収集",
        "ポイント・アンド・クリック"
      ]
    },
    "ko": {
      "title": "스프런키 파핑",
      "description": "스프런키 팝잇: 최종 풍선 터뜨리기 모험! Sprunki PopIt, 어디서나 아이들이 열광하는 무료 온라인 게임으로, 풍선 터뜨리기의 재미를 몇 시간 동안 즐겨보세요! 빠르고 다채로우며 흥미진진한 도전 과제가 가득합니다. 목표는 모든 풍선을 터뜨리고 장애물을 피하고, 풍선 터뜨리기 혼란의 등급을 하나씩克服하는 것입니다!",
      "instructions": "마우스로 플레이하세요.",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "아케이드",
        "회피",
        "구름",
        "수집",
        "포인트 앤 클릭"
      ]
    },
    "fr": {
      "title": "Sprunki PopIt\nSprunki Clique-le",
      "description": "Sprunki PopIt : L'Aventure de Bulles ultime ! Préparez-vous à des heures de plaisir bullesux avec Sprunki PopIt, le jeu en ligne gratuit qui fait furieusement fureur chez les enfants de partout ! C'est rapide, coloré et rempli de défis captivants. Votre objectif ? Éclater toutes les bulles, éviter les obstacles et conquérir niveau après niveau de chaos pur éclatement !",
      "instructions": "Souris pour jouer.",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "arcade",
        "éviter",
        "bulle",
        "collecter",
        "clic et clique"
      ]
    }
  }
};
